import replace404images from '../util/replace404images';

export default {
  init() {
    // JavaScript to be fired on all pages
    replace404images();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};





// WEBPACK FOOTER //
// ./scripts/routes/single.js